// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"EditRecipientNamesModal_modalContainer__13ydt","noBackground":"EditRecipientNamesModal_noBackground__1m97J","input":"EditRecipientNamesModal_input__31-N-"};